import * as Yup from "yup";
import { validateABN } from "../utils/abnUtils";
import { runTextPipeline } from "../utils/contentSafety";
// export const InitialValues = {
//   // username: "",
//   email: "",
//   password: "",
//   // repeatPassword: "",
// };
export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Email is Required")
    .label("Email"),
    password: Yup.string()
    .required("Please enter a password")
    .min(8, "Password too short")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]/,
      `Password must contain at least 
      one uppercase letter, 
      one lowercase letter, 
      one number and one special character`
  )
  // repeatPassword: Yup.string()
  //   .min(6)
  //   .when("password", {
  //     is: (val) => (val && val.length > 0 ? true : false),
  //     then: Yup.string().oneOf(
  //       [Yup.ref("password")],
  //       "Both password need to be the same"
  //     ),
  //   })
  //   .required("Confirm Password Required"),
});



// validationSchema: Yup.object({
//   email: Yup.string()
//       .min(8, 'Must be at least 8 characters')
//       .max(20, 'Must be less  than 20 characters')
//       .required('Email is required')
//       .test('Unique Email', 'Email already in use', // <- key, message
//           function (value) {
//               return new Promise((resolve, reject) => {
//                   axios.get(`http://localhost:8003/api/u/user/${value}/available`)
//                       .then((res) => {
//                           resolve(true)
//                       })
//                       .catch((error) => {
//                           if (error.response.data.content === "The email has already been taken.") {
//                               resolve(false);
//                           }
//                       })
//               })
//           }
//       ),
// }),

// export const verificationCodeInitialValues = {
//   verificationcode: "",
// };

export const verificationCodeSchema = Yup.object().shape({
  verificationCode: Yup.string()
    .length(6, 'Verification code must be exactly 6-digit')
    .required("Verification Code is Required"),
});

export const PersonalDetailsSchema = Yup.object().shape({
    firstName: Yup.string()
    .required('First name is required')
    .test('contentSafety', function (value) {
      if (!value || !String(value).trim()) return true;
      const result = runTextPipeline(value, 'name');
      if (result.valid) return true;
      return this.createError({ message: result.message });
    }),

    lastName: Yup.string()
    .required('Last name is required')
    .test('contentSafety', function (value) {
      if (!value || !String(value).trim()) return true;
      const result = runTextPipeline(value, 'name');
      if (result.valid) return true;
      return this.createError({ message: result.message });
    }),
});

export const BusinessInformationSchema = Yup.object().shape({
  abn: Yup.string()
    .test('isValidABN', 'Please enter a valid ABN', (value) => {
      if (!value) return true; // Allow empty values
      return validateABN(value);
    }),

  businessName: Yup.string()
    .required('Business Name is required')
    .test('contentSafety', function (value) {
      if (!value || !String(value).trim()) return true;
      const result = runTextPipeline(value, 'businessName');
      if (result.valid) return true;
      return this.createError({ message: result.message });
    }),

  companyName: Yup.string()
    .min(3, 'Company name must be at least 3 characters')
    .max(60, 'Company name cannot exceed 60 characters'),
});


export const LocationSchema = Yup.object().shape({
  location: Yup.string()
    .required('Location is required')
    .test('contentSafety', function (value) {
      if (!value || !String(value).trim()) return true;
      const result = runTextPipeline(value, 'location');
      if (result.valid) return true;
      return this.createError({ message: result.message });
    }),
});
